import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
import "../ImportExport/ServicePages.css";
const TDSReturn = () => {
  

 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

  return (
    <div className="service-page">

      {/* SEO */}
      <Helmet>
        <title>TDS Return Filing Service FY 2026-27 | Online TDS Filing India</title>
        <meta
          name="description"
          content="File your TDS returns accurately and on time. Expert TDS filing services for FY 2026-27 including Form 24Q, 26Q, 27Q & 27EQ."
        />
        <meta
          name="keywords"
          content="TDS return filing, Form 24Q, 26Q, 27Q, 27EQ, TDS filing India, FY 2026-27 TDS, online TDS service"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>TDS Return Filing Service</h1>
        <p>Accurate, timely, and compliant TDS filing for FY 2026–27</p>
        <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Tax Deducted at Source (TDS) return filing is a mandatory compliance 
          for all deductors under the Income Tax Act.
        </p>
        <p>
          It involves reporting tax deducted on payments such as salary, rent, 
          contractor payments, interest, and professional fees.
        </p>
        <p>
          For FY 2026–27, stricter compliance rules and higher penalties make 
          accurate and timely filing more important than ever.
        </p>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs to File TDS Returns?</h2>
        <ul>
          <li>Private Limited Companies</li>
          <li>LLPs & Partnership Firms</li>
          <li>Proprietorships (under audit)</li>
          <li>Startups & SMEs</li>
          <li>Any person liable to deduct TDS</li>
        </ul>
      </section>

      {/* TYPES */}
      <section className="service-section">
        <h2>Types of TDS Returns</h2>
        <div className="card">Form 24Q – TDS on Salary</div>
        <div className="card">Form 26Q – TDS on Non-Salary Payments</div>
        <div className="card">Form 27Q – TDS on NRI Payments</div>
        <div className="card">Form 27EQ – TCS Return</div>
      </section>

      {/* UPDATES */}
      <section className="service-section">
        <h2>Key Compliance Updates (FY 2026–27)</h2>
        <ul>
          <li>Enhanced reconciliation with AIS, Form 26AS & TIS</li>
          <li>Stricter penalties for delayed/incorrect filing</li>
          <li>Mandatory PAN & Aadhaar validation</li>
          <li>Faster processing of returns</li>
          <li>Increased scrutiny on high-value transactions</li>
        </ul>
      </section>

      {/* DUE DATES */}
      <section className="service-section">
        <h2>Quarterly Due Dates</h2>
        <div className="card">Q1 (Apr–Jun): 31st July 2026</div>
        <div className="card">Q2 (Jul–Sep): 31st October 2026</div>
        <div className="card">Q3 (Oct–Dec): 31st January 2027</div>
        <div className="card">Q4 (Jan–Mar): 31st May 2027</div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our TDS Filing Services Include</h2>
        <ul>
          <li>Accurate TDS calculation & verification</li>
          <li>Quarterly return filing</li>
          <li>PAN/Aadhaar validation</li>
          <li>TDS reconciliation with books & Form 26AS</li>
          <li>Revised / correction return filing</li>
          <li>Form 16 & 16A generation</li>
          <li>Notice handling support</li>
        </ul>
      </section>

      {/* PENALTIES */}
      <section className="service-section">
        <h2>Penalties for Non-Compliance</h2>
        <ul>
          <li>₹200 per day late filing fee (Section 234E)</li>
          <li>Penalty up to ₹1,00,000</li>
          <li>Interest on late deduction/deposit</li>
          <li>Disallowance of expenses</li>
        </ul>
      </section>

      {/* IMPORTANCE */}
      <section className="service-section">
        <h2>Why TDS Filing is Important?</h2>
        <ul>
          <li>✔ Avoid heavy penalties & notices</li>
          <li>✔ Ensure correct tax credit</li>
          <li>✔ Maintain business credibility</li>
          <li>✔ Smooth audits & assessments</li>
          <li>✔ Legal compliance</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>TAN Details</li>
          <li>PAN of Deductor & Deductees</li>
          <li>Payment & TDS details</li>
          <li>Salary records (Form 24Q)</li>
          <li>Previous TDS returns</li>
        </ul>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Updated with FY 2026–27 rules</li>
          <li>✔ 100% accurate filing</li>
          <li>✔ Timely reminders</li>
          <li>✔ Affordable pricing</li>
          <li>✔ Dedicated expert support</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Stay TDS Compliant</h2>
        <p>Avoid penalties and ensure smooth filings with expert help.</p>
        <button>Get Started Now</button>
      </section> */}

    <div className="cta" ref={contactRef}>
              <h2>Stay TDS Compliant</h2>
              <p>Avoid penalties and ensure smooth filings with expert help.</p>
      
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Get Started Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>
    </div>
  );
};

export default TDSReturn;